// ── PageTabs — sub-navigation tab bar inside a page ──────────────────────────

export interface TabDef {
  key:      string;
  label:    string;
  disabled?: boolean;
  soon?:    boolean;
}

interface PageTabsProps {
  tabs:     TabDef[];
  active:   string;
  onChange: (key: string) => void;
  /** Extra class on the wrapper — e.g. so one call site can override the
   *  active-tab color via a scoped CSS rule instead of touching the shared
   *  `.page-tab-btn.active` style every other page relies on. */
  className?: string;
}

export function PageTabs({ tabs, active, onChange, className }: PageTabsProps) {
  return (
    <div className={`page-tabs${className ? ` ${className}` : ''}`}>
      {tabs.map(tab => (
        <button
          key={tab.key}
          className={`page-tab-btn${active === tab.key ? ' active' : ''}`}
          disabled={tab.disabled}
          onClick={() => !tab.disabled && onChange(tab.key)}
        >
          {tab.label}
          {tab.soon && <span className="tab-soon">Soon</span>}
        </button>
      ))}
    </div>
  );
}
